var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_6717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.75V20.125C8.75 20.3571 8.84219 20.5796 9.00628 20.7437C9.17038 20.9078 9.39294 21 9.625 21H20.1709L24.5 24.5V10.5C24.5 10.2679 24.4078 10.0454 24.2437 9.88128C24.0796 9.71719 23.8571 9.625 23.625 9.625H19.25V14.875C19.25 15.1071 19.1578 15.3296 18.9937 15.4937C18.8296 15.6578 18.6071 15.75 18.375 15.75H8.75Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82906 15.75L3.5 19.25V5.25C3.5 5.01794 3.59219 4.79538 3.75628 4.63128C3.92038 4.46719 4.14294 4.375 4.375 4.375H18.375C18.6071 4.375 18.8296 4.46719 18.9937 4.63128C19.1578 4.79538 19.25 5.01794 19.25 5.25V14.875C19.25 15.1071 19.1578 15.3296 18.9937 15.4937C18.8296 15.6578 18.6071 15.75 18.375 15.75H7.82906Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.75V20.125C8.75 20.3571 8.84219 20.5796 9.00628 20.7437C9.17038 20.9078 9.39294 21 9.625 21H20.1709L24.5 24.5V10.5C24.5 10.2679 24.4078 10.0454 24.2437 9.88128C24.0796 9.71719 23.8571 9.625 23.625 9.625H19.25",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_6717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBlack);
export default __webpack_public_path__ + "static/media/contactBlack.65e71502.svg";
export { ForwardRef as ReactComponent };